import React from 'react';
import PropTypes from 'prop-types';

const StoveNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      d="M22.585 4H1.345C1.139 4 1 4.138 1 4.346V20.95c0 .207.138.346.346.346h21.308c.208 0 .346-.139.346-.346V4.346c-.07-.208-.207-.346-.415-.346Zm-20.893.692h15.704v15.912H1.692V4.692Zm20.616 15.912h-4.22V4.692h4.22v15.912Z"
    />
    <path
      fill={color}
      d="M5.843 5.66c-1.73 0-3.183 1.453-3.183 3.252 0 1.799 1.453 3.251 3.183 3.251 1.73 0 3.182-1.452 3.182-3.251S7.572 5.66 5.843 5.66Zm0 5.812c-1.384 0-2.56-1.176-2.56-2.56 0-1.384 1.176-2.56 2.56-2.56 1.383 0 2.56 1.176 2.56 2.56 0 1.383-1.177 2.56-2.56 2.56ZM13.176 11.333c1.315 0 2.352-1.107 2.352-2.421 0-1.315-1.037-2.421-2.352-2.421-1.314 0-2.352 1.106-2.352 2.42 0 1.315 1.038 2.422 2.352 2.422Zm0-4.15c.969 0 1.73.76 1.73 1.729 0 .968-.761 1.73-1.73 1.73-.968 0-1.73-.762-1.73-1.73 0-.969.83-1.73 1.73-1.73ZM13.176 13.962c-1.314 0-2.352 1.107-2.352 2.422 0 1.314 1.038 2.421 2.352 2.421 1.315 0 2.352-1.107 2.352-2.421 0-1.315-1.037-2.422-2.352-2.422Zm0 4.151c-.968 0-1.73-.76-1.73-1.73 0-.968.762-1.729 1.73-1.729.969 0 1.73.761 1.73 1.73 0 .968-.761 1.73-1.73 1.73ZM5.843 13.132c-1.73 0-3.183 1.453-3.183 3.252 0 1.798 1.453 3.251 3.183 3.251 1.73 0 3.182-1.453 3.182-3.251 0-1.8-1.453-3.252-3.182-3.252Zm0 5.811c-1.384 0-2.56-1.176-2.56-2.56 0-1.383 1.176-2.56 2.56-2.56 1.383 0 2.56 1.177 2.56 2.56 0 1.384-1.177 2.56-2.56 2.56ZM20.163 15.138c.485 0 .83-.346.83-.83s-.345-.83-.83-.83c-.484 0-.83.346-.83.83s.346.83.83.83ZM20.163 16.799c-.484 0-.83.346-.83.83s.346.83.83.83c.485 0 .83-.346.83-.83s-.345-.83-.83-.83ZM20.163 8.497c.485 0 .83-.346.83-.83 0-.485-.345-.83-.83-.83-.484 0-.83.345-.83.83 0 .484.346.83.83.83ZM20.163 11.818c.485 0 .83-.346.83-.83 0-.485-.345-.83-.83-.83-.484 0-.83.345-.83.83 0 .484.346.83.83.83Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

StoveNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default StoveNot;
